import { render } from "./SquareImg.vue?vue&type=template&id=64bcc12b&scoped=true"
import script from "./SquareImg.vue?vue&type=script&lang=js"
export * from "./SquareImg.vue?vue&type=script&lang=js"

import "./SquareImg.vue?vue&type=style&index=0&id=64bcc12b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bcc12b"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
